export const vaccinationControlTags = {
  CONTROL: 'control',
};
